import LcChopFont from "./LcChopFont";

export { LcChopFont };
export default LcChopFont;
